export default __webpack_public_path__ + "static/media/Austria-vs-North-Macedonia.d361ea77.jpeg";